var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgThumbtack = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.784,
    height: 23.912,
    viewBox: "0 0 23.784 23.912",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6-thumbtack",
    transform: "translate(-3.7 -3.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M27.166,12.352,18.7,3.889a.93.93,0,0,0-1.346,0L14.279,6.966a.923.923,0,0,0,0,1.346l.673.673-2.885,2.885c-1.443-.289-5.386-.962-7.5,1.154a.93.93,0,0,0,0,1.346l5.482,5.482L3.989,25.912a.93.93,0,0,0,0,1.346,1.022,1.022,0,0,0,1.346,0L11.394,21.2l5.482,5.482a.905.905,0,0,0,1.346,0c2.116-2.116,1.443-6.059,1.154-7.5l2.885-2.885.673.673a.93.93,0,0,0,1.346,0l3.077-3.077a1.452,1.452,0,0,0-.192-1.539Zm-3.751,2.4-.673-.673a.93.93,0,0,0-1.346,0l-3.943,4.039a.923.923,0,0,0-.289.962c.289,1.058.769,3.654,0,5.386L6.585,13.89c1.635-.769,4.328-.289,5.386,0a.976.976,0,0,0,.962-.289l3.943-3.943a.849.849,0,0,0,0-1.346L16.2,7.639l1.827-1.731,7.117,7.117Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThumbtack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thumbtack.66487b2e.svg";
export { ForwardRef as ReactComponent };